import React from 'react'
import "./About.css"



export default function About() {

  return (

    <div >

     


      <div className='aboutme'>

      <h1>About Me</h1>
   
    
      <p>Ambitious, goal-oriented with experience in effective
         collaboration and a keen interest in solving problems.
        Passionate about coding and eager to learn more while
        working in a reputed organization.</p>



     </div>
   
   
     
    </div>
  )
}
